import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Header from './Components/Header/Header';
import Landing from './Components/Landing/Landing';
import Footer from './Components/Footer/Footer';
import Products from './Components/Products/Products';
import ProductInfo from './Components/ProductInfo/ProductInfo';
import About from './Components/About/About';
import Contact from './Components/Contact/Contact';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Quality from './Components/Quality/Quality';
import RawMaterials from './Components/RawMaterials/RawMaterials';
import WhyChooseUs from './Components/WhyChooseUs/WhyChooseUs';
import ProductsList from './Components/Products/ProductsList';
import ProductsCategories from './Components/Products/ProductsCategories';
import TermsAndConditions from './Components/Policies/TermsAndConditions';
import TermsAndConditionsForSales from './Components/Policies/TermsAndConditionsForSales';

function App() {

  useEffect(() => {

  }, [])

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path='*' element={<Landing />} />
        <Route path='/' element={<Landing />} />
        <Route path='/products' element={<Products />} />
        <Route path='/products-list' element={<ProductsList />} />
        <Route path='/products-categories' element={<ProductsCategories />} />
        <Route path='/products/:id' element={<ProductInfo />} />
        <Route path='/about' element={<About />} />
        <Route path='/quality-assurance' element={<Quality />} />
        <Route path='/join-us' element={<RawMaterials />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/why-choose-us' element={<WhyChooseUs />} />
        <Route path='/terms-and-conditions-for-purchase' element={<TermsAndConditions />} />
        <Route path='/po-terms' element={<TermsAndConditionsForSales />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
